import { useEffect, useState } from 'react';
import { API_BASE } from '../../config/api';

// cat drives the Work page filter: full | update | fixes
export const GAMES = [
  { id: '9639553972', title: 'Survive the Cold', studio: 'Black Swan Hunters', role: 'Full game', cat: 'full' },
  { id: '9468928549', title: 'Launch Your Rocket', studio: 'Optidash', role: 'Update', cat: 'update' },
  { id: '4875171195', title: 'Boat Empire Tycoon', studio: 'Pexran Studios', role: 'Bug fixes', cat: 'fixes' },
  { id: '9344819762', title: 'Find The Skifidol Brainrot Card', studio: 'Black Swan Hunters', role: 'Update', cat: 'update' },
  { id: '6879247920', title: 'City Go', studio: 'Black Swan Hunters', role: 'Update', cat: 'update' },
  { id: '5837175781', title: 'Murder Drones Tower Defense', studio: 'Ymyfalt Developments', role: 'Full game', cat: 'full' },
  { id: '3723094046', title: 'Dodge Stars', studio: 'Dodge Stars', role: 'Bug fixes', cat: 'fixes' },
  { id: '7766358541', title: 'The Slowest Race', studio: 'Black Swan Hunters', role: 'Full game', cat: 'full' },
  { id: '7581722074', title: "What's in the BOX?", studio: 'Black Swan Hunters', role: 'Full game', cat: 'full' },
  { id: '10769501304', title: 'Stranded: Mine to Survive', studio: 'Black Swan Hunters', role: 'Full game', cat: 'full' },
];

export const GOLDEN_GAMES = [
  { title: 'Multiverse KO', icon: '/icons/games/multiverse-ko.png' },
  { title: 'Monarch', icon: '/icons/games/monarch.png' },
  { title: 'Friday Night Devs', icon: '/icons/games/friday-night-devs.png' },
  { title: "Conqueror's Battleground", icon: '/icons/games/conquerors-battleground.png' },
];

// Titles across every studio and client (GAMES + Golden Games).
export const TITLE_COUNT = GAMES.length + GOLDEN_GAMES.length;

export const PLACEHOLDER_IMG = '/game1-placeholder.jpg';

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });
export const formatCount = (n) => (typeof n === 'number' ? compact.format(n) : '…');

// Live visits / players / thumbnails from Roblox via the Worker proxy.
// Returns GAMES merged with { visits, playing, image }; stats stay undefined until loaded.
export function useGames() {
  const [games, setGames] = useState(GAMES);

  useEffect(() => {
    let cancelled = false;
    const ids = GAMES.map((g) => g.id).join(',');
    const get = (path) =>
      fetch(`${API_BASE}${path}?universeIds=${ids}`)
        .then((r) => (r.ok ? r.json() : { data: [] }))
        .catch(() => ({ data: [] }));

    const load = async () => {
      const [stats, thumbs] = await Promise.all([get('/api/games'), get('/api/thumbnails')]);
      if (cancelled) return;
      setGames(
        GAMES.map((g) => {
          const s = (stats.data || []).find((d) => String(d.id) === g.id);
          const t = (thumbs.data || []).find((d) => String(d.universeId) === g.id);
          return {
            ...g,
            visits: s?.visits,
            playing: s?.playing,
            image: t?.thumbnails?.[0]?.imageUrl || PLACEHOLDER_IMG,
          };
        })
      );
    };

    load();
    const interval = setInterval(load, 300000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return games;
}
